module.exports = __webpack_public_path__ + "static/media/9.7990c580.jpg";